import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FollowUpQueue } from './pages/FollowUpQueue';
import { Campaigns } from './pages/Campaigns';
import { Calendar } from './pages/Calendar';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<FollowUpQueue data-id="element-3" />} data-id="element-2" />
        <Route path="/campaigns" element={<Campaigns data-id="element-5" />} data-id="element-4" />
        <Route path="/calendar" element={<Calendar data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}